import { useTranslation } from 'react-i18next';
import { Input } from '../../ui/input';

export interface RateLimitFieldsProps {
  requestsPerHour: number;
  onRequestsPerHourChange: (v: number) => void;
  min?: number;
  max?: number;
  className?: string;
  /** optional note below the field (integration-specific) */
  helperKey?: 'default' | 'customGPT';
}

export function RateLimitFields({
  requestsPerHour,
  onRequestsPerHourChange,
  min = 1,
  max = 100000,
  className = '',
  helperKey = 'default',
}: RateLimitFieldsProps) {
  const { t } = useTranslation('integrations');

  return (
    <div className={`space-y-2 ${className}`}>
      <label className="text-gray-600 text-xs font-medium">
        {t('bindingSections.rateLimit.label')}
      </label>
      <Input
        type="number"
        min={min}
        max={max}
        value={requestsPerHour}
        onChange={(e) =>
          onRequestsPerHourChange(parseInt(e.target.value, 10) || min)
        }
        className="bg-white border-gray-300 text-gray-900 text-sm max-w-xs"
      />
      {helperKey === 'customGPT' && (
        <p className="text-xs text-gray-500">
          {t('bindingSections.rateLimit.helpCustomGPT')}
        </p>
      )}
      {helperKey === 'default' && (
        <p className="text-gray-500 text-xs">{t('bindingSections.rateLimit.help')}</p>
      )}
    </div>
  );
}
